import(/* webpackMode: "eager" */ "/app/src/app/(site)/web/error.tsx");
